import React from "react";
import TopBar from "../../../../components/Modules/TopBar";
import { TopBarSectionProps } from "../types/SurveyTypes";

const TopBarSection: React.FC<TopBarSectionProps> = ({
  Headers,
  sections,
  page = 0,
  themeManager,
  onClose
}) => {
  return (
    <TopBar
      heading={(Array.isArray(Headers) && Headers[page]?.heading) || ""}
      description={(Array.isArray(Headers) && Headers[page]?.subHeading) || ""}
      style={themeManager.getTopBarStyles()}
      onClose={onClose}
    />
  );
};

export default TopBarSection;
